module.exports = __webpack_public_path__ + "media/application/images/ui/icon-information-8e11963f5a8059157f1389cf84f58568.png";